// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#macro-dialog .modal-body {\n  padding: 0 0 0.5rem 0 !important;\n  height: 60vh;\n}\n", ""]);
// Exports
module.exports = exports;
